import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/:cardId/validate/';

type ValidateCardInParkingFnType = typeof validateCardInParking;

export type ValidateCreateDTO = {
    parkingId: string;
    cardId: number;
    validation_reason: string;
};

const validateCardInParking = ({ parkingId, cardId, ...data }: ValidateCreateDTO) => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, cardId }), data);
};

interface UseValidateCardInParkingOptions extends MutationConfig<ValidateCardInParkingFnType, GeneralSmartParkError> {}

export const useValidateCardInParking = (options: UseValidateCardInParkingOptions) =>
    useMutation({
        mutationFn: validateCardInParking,
        ...options,
    });
